import { DatePipe } from '@angular/common';
import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ElementRef,
  SimpleChanges
} from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { Subject, forkJoin, map, Observable, takeUntil } from 'rxjs';
import {
  EventDocumentStatus as DocumentStatus,
  EventDocumentType,
  EventDocumentTypeIds,
  EventType,
  ProgramTypesGUID,
  EventCustomerValidationType,
  EventCustomerValidationStatus,
  SurveyStatus,
  EventCustomerValidationStatusNames
} from '../../../../../models/_enum-collections';
import {
  CustomerSurvey,
  CustomerSurveySubmissionModel
} from '../../../../../models/customer-survey-submission.model';
import { CustomerSurveyModel } from '../../../../../models/customer-survey.,model';
import { CustomerPreviewInput } from '../../../../../models/customer-validation-preview-input.model';
import { EventCustomerRejectionReason } from '../../../../../models/event-customer-rejection-reason.model';
import {
  EventCustomerValidationModel,
  EventCustomerValidationStatusDataItem
} from '../../../../../models/event-customer-validation.model';
import { EventDocumentRejectionReason } from '../../../../../models/event-document-rejection-reason.model';
import { EventDocumentStatus } from '../../../../../models/event-document-status.model';
import { EventPoeDocument } from '../../../../../models/event-poe-document.model';
import { EventPOEInfoModel } from '../../../../../models/event-poe-info.model';
import {
  EventPreviewInput,
  MrppPreviewInput
} from '../../../../../models/event-preview-input.model';
import { EventRegistrationDocumentStatusRequest } from '../../../../../models/event-registration-document-status-request.model';
import {
  EventRegistrationDocumentModel,
  EventDocument,
  EventRegistrationDocumentHistory,
  POEDocument,
  ProgramDocument
} from '../../../../../models/event-registration-document.model';
import { EventRequiredCustomerLimit } from '../../../../../models/event-required-customer-attendee-limit.model';
import { EventSurveyRejectReason } from '../../../../../models/event-survey-reject-reason.model';
import { PoeDocHyperLink } from '../../../../../models/poe-doc-hyper-link.model';
import { POEStatus } from '../../../../../models/poe-status-type.model';
import { SurveyDetails } from '../../../../../models/survey-details.model';
import { AppConstants } from '../../../../common/app-constants';
import { ProgramSharedService } from '../../../../common/program-shared.service';
import { EventSurveyStatus } from '../../../../../models/event-survey-status.model';
import { EventPOEStatus } from '../../../../../models/event-poe-status.model';
import { PoeDocument } from '../../../../../models/poe-document.model';
import { UpdateEventDocumentsStatusRequest } from '../../../../../models/update-event-documents-status-request.model';
import {
  EventCustomerValidationInfoRequestModel,
  EventCustomerValidationRequestModel
} from '../../../../../models/event-customer-validation-request.model';
import { CommonSharedModule } from '../../../../common/shared.module';
import { EventEditService } from '../../../../services/event-edit.service';
import { EventPreviewComponent } from '../../../preview/event-preview/event-preview.component';
import { MrppPreviewComponent } from '../../../../mrpp/mrpp-preview/mrpp-preview.component';
import { CustomerValidationPreviewComponent } from '../../../preview/customer-validation-preview/customer-validation-preview.component';

@Component({
  selector: 'app-event-poe-submission',
  templateUrl: './event-poe-submission.component.html',
  styleUrls: ['./event-poe-submission.component.scss'],
  standalone: true,
  imports: [
    CommonSharedModule,
    EventPreviewComponent,
    MrppPreviewComponent,
    CustomerValidationPreviewComponent
  ]
})
export class EventPoeSubmissionComponent
  implements OnInit, OnChanges, OnDestroy
{
  @Input() eventRegistrationId!: number;
  @Input() programTypeGUID!: string;
  surveyDetails!: SurveyDetails;
  customerEventSurveyStatus!: EventSurveyStatus[];
  customerEventSurveyRejectReason!: EventSurveyRejectReason[];
  poeRequiredDocuments!: PoeDocHyperLink[];
  poeEventTableRow!: number;
  poeSavedDocuments!: PoeDocHyperLink[];
  poeSavedTableRow!: number;
  eventCustomerSurveys!: CustomerSurveyModel[];
  isReadonlyCustomerValidation = true;
  eventCustomerValidations!: EventCustomerValidationModel[];
  rejectionReasons!: EventCustomerRejectionReason[];
  validationStatuses!: EventCustomerValidationStatusDataItem[];
  msgsCustValidation!: any[];
  btnNavCustValidation = false;
  eventPOEStatus!: EventPOEStatus[];
  eventCustomerSurveyStatus!: EventSurveyStatus[];
  rejectedSurveyStatus?: EventSurveyStatus;
  eventCustomerSurveyRejectReasons!: EventSurveyRejectReason[];
  eventRegistrationDocumentModel!: EventRegistrationDocumentModel;
  eventCustomerSurveyRejectReasonList!: EventSurveyRejectReason[];
  customerId = 0;
  CusSurveyGUID = '';
  customerSurvey!: CustomerSurvey;
  msgsCustSurvey!: any[];
  isReadonlyCustomerSurvey = true;
  btnCustomerSurvey = false;
  documents!: EventDocument[];
  documentHistories!: EventRegistrationDocumentHistory[];
  msgsEventDocumentsStatus!: any[];
  eventDocumentStatus!: EventDocumentStatus[];
  eventDocumentRejectionReasonsList!: EventDocumentRejectionReason[];
  isPOEDocumentEditMode = false;
  isMRPPProgram = false;
  eventPOEInfo?: EventPOEInfoModel;
  isReadonlyPOEStatus = true;
  btnPoeStatus = false;
  formPOEStatus!: FormGroup;
  msgsPoeStatus!: any[];
  isUploading = false;
  isButtonActive = true;
  maxYearDate!: Date;

  customerName!: string;
  isSurveyResponseload = false;
  disableRequiredDocSave = false;
  disableCustSurveySave = false;
  isCustomerSurveyCompletedStatus = false;
  customerLimit!: EventRequiredCustomerLimit;
  loadUploadDialog = false;
  docType!: number;
  onDestroy$: Subject<void> = new Subject<void>();
  canShowEventPreviewModel = false;
  eventPreviewInput!: EventPreviewInput;
  mrppPreviewInput!: MrppPreviewInput;
  canShowCustomerValidationPreviewModel = false;
  customerValidationPreviewInput!: CustomerPreviewInput;
  documentType = EventDocumentType;
  storePOEDocument!: POEDocument;
  // eslint-disable-next-line no-empty-pattern
  filesUpload: any = ([] = []);
  fileUploadSpinners: boolean[] = [];
  downloadSpin: boolean[] = [];
  poeDocMaximumFiles = 1;
  umsgs: any[] = [];
  selectedSurveyReasons: number[] = [];
  eventPOEStatusId!: number;

  @Output() refreshEventDetails = new EventEmitter();
  @ViewChild('fileInputUpload', { static: true }) myfileInput!: ElementRef;

  buttonConfig = [
    {
      eventType: EventType.DealAssociation,
      documentType: EventDocumentTypeIds.DealAssociationTemplate,
      label: 'Add Deal Reg POE Template'
    },
    {
      eventType: EventType.DealAssociation,
      documentType: EventDocumentTypeIds.CustomerPartnerOfRecord,
      label: 'Add Deal Reg CPOR Template'
    },
    {
      eventType: EventType.DealAssociationRequestforProposal,
      documentType: EventDocumentTypeIds.DealAssociationTemplateRFP,
      label: 'Add Deal Reg RFP POE Template'
    },
    {
      eventType: EventType.DealAssociationRequestforProposal,
      documentType: EventDocumentTypeIds.CustomerAwardLetter,
      label: 'Add Deal Reg RFP Award Letter'
    },
    {
      eventType: EventType.TeamsRoomsPilot,
      documentType: EventDocumentTypeIds.PublicSectorPOE,
      label: 'Add Public Sector Template'
    },
    {
      eventType: EventType.TeamsRoomsPilot,
      documentType: EventDocumentTypeIds.MicrosoftInvoiceTemplate,
      label: 'Add Microsoft Invoice Template'
    },
    {
      eventType: EventType.TeamsRoomsPilot,
      documentType: EventDocumentTypeIds.FindingsTemplate,
      label: 'Add POE Template'
    },
    {
      eventType: EventType.TeamsRoomsOneToMany,
      documentType: EventDocumentTypeIds.POEInvoice,
      label: 'Add POE Invoice'
    }
  ];

  constructor(
    private eventEdit: EventEditService,
    private formBuilder: FormBuilder,
    public programSharedService: ProgramSharedService
  ) {}

  ngOnInit() {
    this.isMRPPProgram =
      this.programTypeGUID !== undefined &&
      this.programTypeGUID == ProgramTypesGUID.MRPP;

    this.getCustomerMinimumLimit();
    this.onFormGroup();
    this.getEventPOEStatusDropDown();
    this.getEventSurveyStatusDropDown();
    this.getEventSurveyRejectionReasonDropDown();
    this.getEventCustomerSurveyList();
    this.getSurveyDetails();
    forkJoin([
      this.getRejectionReasonDropdown(),
      this.getValidationStatusDropdown(),
      this.getEventCustomerValidationInfo()
    ]).subscribe(([,]) => {
      this.loadEventCustomerValidationSection();
      this.getEventCustomerSurveyList();
    });
    this.loadDocumentRejectionReasons();
    this.loadEventDocumentStatus();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['eventRegistrationId'].firstChange === false) {
      this.ngOnInit();
    }
  }

  onFormGroup() {
    this.maxYearDate = new Date(
      new Date().setFullYear(new Date().getFullYear())
    );
    this.formPOEStatus = this.formBuilder.group({
      poeStatus: [''],
      poeDocumentSubmittedDate: [''],
      poeCompletionDate: ['']
    });
    this.formPOEStatus.disable();
  }

  editPoeStatusCancel() {
    this.isReadonlyPOEStatus = true;
    this.msgsPoeStatus = [];
    this.btnPoeStatus = false;
    this.getEventPoeInformation();
    this.formPOEStatus.disable();
  }

  editPoeStatus() {
    this.isReadonlyPOEStatus = false;
    this.btnPoeStatus = true;
    this.formPOEStatus.enable();
  }

  getSurveyDetails() {
    this.eventEdit
      .getSurveyDetails(this.eventRegistrationId)
      .subscribe(result => {
        this.surveyDetails = result;
      });
  }

  getCustomerMinimumLimit() {
    this.eventEdit
      .getRequiredCustomerLimit(this.eventRegistrationId)
      .subscribe(data => {
        this.customerLimit = data;
      });
  }

  getEventSurveyStatusDropDown() {
    this.eventEdit
      .getEventSurveyStatusDropDown()
      .subscribe(EventSurveyStatusList => {
        this.eventCustomerSurveyStatus = EventSurveyStatusList;
        this.rejectedSurveyStatus = this.eventCustomerSurveyStatus.find(
          status => status.name == 'Rejected'
        );
      });
  }

  getEventSurveyRejectionReasonDropDown() {
    this.eventEdit
      .getEventSurveyRejectionReasonDropDown()
      .subscribe(eventSurveyRejectReasonsResponse => {
        this.eventCustomerSurveyRejectReasons =
          eventSurveyRejectReasonsResponse;
      });
  }

  loadEventCustomerValidationSection() {
    if (this.eventCustomerValidations.length > 0) {
      this.eventCustomerValidations.forEach(item => {
        switch (item.eventCustomerValidationTypeId) {
          case EventCustomerValidationType.TenantID:
            item.eventCustomerValidationDetail = item.tenantId || '';
            break;
          case EventCustomerValidationType.TPID:
            item.eventCustomerValidationDetail = item.tpid || '';
            break;
          case EventCustomerValidationType.DB:
            item.eventCustomerValidationDetail = item.dbNumber || '';
            break;
          case EventCustomerValidationType.WebURL:
            item.eventCustomerValidationDetail = item.webUrl || '';
            break;
          case EventCustomerValidationType.SubscriptionId:
            item.eventCustomerValidationDetail = item.subscriptionId || '';
            break;
        }
        item.isEdited = false;
        item.selectedValidationStatus = this.validationStatuses.find(
          s =>
            s.eventCustomerValidationStatusId ===
            item.eventCustomerValidationStatusId
        );
        if (
          item.eventCustomerRejectionReason != null &&
          item.eventCustomerValidationStatus !=
            EventCustomerValidationStatusNames.Approved
        ) {
          item.isValidationRejectionVisible = true;
          item.selectedRejectionReason = {
            eventCustomerRejectionReasonId:
              item.eventCustomerRejectionReasonId || -1,
            rejectReasonDescription: item.eventCustomerRejectionReason
          };
        }
      });

      this.customerId = this.eventCustomerValidations[0].eventCustomerId;
      this.customerName = this.eventCustomerValidations[0].customerName;
    }
  }

  getEventCustomerValidationInfo() {
    const response = this.eventEdit
      .getEventCustomerValidationResponse(this.eventRegistrationId)
      .pipe(
        map(eventCustomerValidationResponse => {
          this.eventCustomerValidations = eventCustomerValidationResponse;
          return eventCustomerValidationResponse;
        })
      );
    return response;
  }

  getEventPOEStatusDropDown() {
    this.eventEdit
      .getEventPOEStatusDropDown()
      .subscribe(eventPoeStatusesResponse => {
        this.eventPOEStatus = eventPoeStatusesResponse;
        this.getEventPoeInformation();
      });
  }

  getEventPoeInformation() {
    this.eventEdit
      .getEventPoeInformation(this.eventRegistrationId)
      .subscribe(EventPoeInfo => {
        const selectedPoeStatus = this.eventPOEStatus.find(
          x => x.eventPOEStatusId == EventPoeInfo.eventPoestatusId
        );

        this.eventPOEInfo = EventPoeInfo;

        if (selectedPoeStatus) {
          this.eventPOEStatusId = selectedPoeStatus.eventPOEStatusId;
        }

        const datePipe = new DatePipe('en-US');
        const PoeDocumentSubmittedDate = datePipe.transform(
          EventPoeInfo.poeDocumentSubmittedDate,
          'MM/dd/yyyy'
        );
        const PoeCompletionDate = datePipe.transform(
          EventPoeInfo.poeCompletionDate,
          'MM/dd/yyyy'
        );

        this.formPOEStatus.patchValue({
          poeDocumentSubmittedDate: PoeDocumentSubmittedDate,
          poeCompletionDate: PoeCompletionDate,
          poeStatus: selectedPoeStatus
        });
      });
  }

  resetPoeInfo() {
    this.btnPoeStatus = false;
    this.getEventPoeInformation();
  }

  onSubmitPoeStatus() {
    const datePipe = new DatePipe('en-US');

    const PoeStatus = this.eventPOEStatus.find(
      x => x.eventPOEStatusId === this.formPOEStatus.controls['poeStatus'].value.eventPOEStatusId
    );

    const poeCompletionDate = datePipe.transform(
      this.formPOEStatus.controls['poeCompletionDate'].value,
      'MM/dd/yyyy'
    );

    const poeDocumentSubmittedDate = datePipe.transform(
      this.formPOEStatus.controls['poeDocumentSubmittedDate'].value,
      'MM/dd/yyyy'
    );

    this.eventPOEInfo = {
      eventPoestatusId: PoeStatus?.eventPOEStatusId || -1,
      eventPoeStatusName: PoeStatus?.name || '',
      eventRegistrationId: this.eventRegistrationId,
      poeCompletionDate: poeCompletionDate ? poeCompletionDate : '',
      poeDocumentSubmittedDate: poeDocumentSubmittedDate
        ? new Date(poeDocumentSubmittedDate)
        : new Date()
    };

    this.eventEdit.updateEventPoeInformation(this.eventPOEInfo).subscribe(
      () => {
        this.getEventPoeInformation();
        this.refreshEventDetails.emit();
        this.btnPoeStatus = false;
        this.isReadonlyPOEStatus = true;
        this.msgsPoeStatus = [];
        this.msgsPoeStatus.push({
          severity: 'success',
          detail: !this.isMRPPProgram
            ? 'Event Details Updated Successfully'
            : 'POE Details Updated successfully'
        });
        this.formPOEStatus.disable();

        if (
          (this.btnNavCustValidation || this.btnCustomerSurvey) &&
          this.eventPOEInfo?.eventPoestatusId == POEStatus.Completed &&
          this.programSharedService.checkEventType(
            EventType.TeamsRoomsOneToMany
          )
        ) {
          this.getEventCustomerValidationInfo().subscribe(() => {
            this.loadEventCustomerValidationSection();
            this.getEventCustomerSurveyList();
          });
        }
      },
      () => {
        this.msgsPoeStatus = [];
        this.msgsPoeStatus.push({
          severity: 'warn',
          detail: !this.isMRPPProgram
            ? 'Sorry an Error Occured while Updating Event Details'
            : 'Sorry an Error Occured while Updating POE Details'
        });
      }
    );
  }

  getRejectionReasonDropdown(): Observable<EventCustomerRejectionReason[]> {
    const response = this.eventEdit.getCustomerRejectionReasonsDropDown().pipe(
      map(eventCustomerRejectionReason => {
        this.rejectionReasons = eventCustomerRejectionReason;
        return eventCustomerRejectionReason;
      })
    );
    return response;
  }

  getValidationStatusDropdown(): Observable<
    EventCustomerValidationStatusDataItem[]
  > {
    const response = this.eventEdit
      .getCustomerValidationStatusesDropDown()
      .pipe(
        map(eventCustomerValidationStatusesResponse => {
          this.validationStatuses = eventCustomerValidationStatusesResponse;
          return eventCustomerValidationStatusesResponse;
        })
      );
    return response;
  }

  onSubmitCustomerValidation() {
    const customerValidationSubmissionModel: EventCustomerValidationRequestModel =
      {
        eventRegistrationId: this.eventRegistrationId,
        customerValidationStatus: []
      };

    const editedCustomerValidations = this.eventCustomerValidations.filter(
      validation => validation.isEdited === true
    );

    editedCustomerValidations.forEach(validationInput => {
      const isRejected =
        validationInput?.selectedValidationStatus?.name ===
        EventCustomerValidationStatusNames.Rejected;

      const infoRequest: EventCustomerValidationInfoRequestModel = {
        eventCustomerId: validationInput.eventCustomerId,
        eventCustomerValidationStatusId:
          validationInput.selectedValidationStatus
            ? validationInput.selectedValidationStatus
                .eventCustomerValidationStatusId
            : -1,
        ...(isRejected && {
          eventCustomerRejectionReasonId:
            validationInput.selectedRejectionReason?.eventCustomerRejectionReasonId
        })
      };

      customerValidationSubmissionModel.customerValidationStatus.push(
        infoRequest
      );
    });

    this.eventEdit
      .updateCustomerValidationStatuses(customerValidationSubmissionModel)
      .subscribe(
        () => {
          if (this.eventCustomerValidations && this.eventCustomerValidations.length > 0) {
            this.eventCustomerValidations.forEach(item => {
              item.isEdited = false;
            });
          }
          this.btnNavCustValidation = false;
          this.getEventCustomerValidationInfo();
          this.refreshEventDetails.emit();
          this.msgsCustValidation = [];
          this.msgsCustValidation.push({
            severity: 'success',
            detail: 'Customer Validation saved successfully.'
          });

          this.isReadonlyCustomerValidation = true;
          this.btnPoeStatus = false;
          this.getEventPoeInformation();
        },
        () => {
          this.msgsCustValidation = [];
          this.msgsCustValidation.push({
            severity: 'warn',
            detail:
              'Sorry, an error has occured while updating Customer Validation'
          });
        }
      );
  }

  onChangeValidationStatus(dataItem: EventCustomerValidationModel) {
    dataItem.isEdited = true;

    if (
      dataItem.selectedValidationStatus &&
      (dataItem as any).selectedValidationStatus
        .eventCustomerValidationStatusId ===
        EventCustomerValidationStatus.Rejected
    ) {
      dataItem.isValidationRejectionVisible = true;
    } else {
      dataItem.isValidationRejectionVisible = false;
      dataItem.eventCustomerRejectionReason = '';
    }
  }

  onChangeDocStatus(dataItem: EventDocument) {
    dataItem.isEdited = true;
    const selectedDocumentStatusId = (dataItem as any).selectedDocumentStatus;
    const documentStatus = this.eventDocumentStatus.find(
      x => x.eventDocumentStatusId == selectedDocumentStatusId
    );

    const documentStatusName = documentStatus?.name;

    if (documentStatusName && documentStatusName === 'Rejected') {
      this.disableRequiredDocSave = true;
      if (dataItem.selectableEventDocumentRejectionReasons) {
        if (dataItem.previousSelectedDocumentStatus === null) {
          this.reloadDocument();
        } else {
          dataItem.selectedDocumentStatus =
            dataItem.previousSelectedDocumentStatus;
        }
        this.msgsEventDocumentsStatus = [];
        this.msgsEventDocumentsStatus.push({
          severity: 'warn',
          detail:
            'There are no rejection reasons available to select for this type of document.'
        });
        return;
      }
      dataItem.isDocStatusRejectionVisible = true;
    } else {
      this.disableRequiredDocSave = false;
      dataItem.isDocStatusRejectionVisible = false;
    }

    dataItem.selectedDocumentRejectionReasons = [];
    dataItem.previousSelectedDocumentStatus = {
      name: documentStatusName || '',
      eventDocumentStatusId: selectedDocumentStatusId || -1
    };
  }

  onChangeRejectionReason(
    dataItem: EventDocument | EventCustomerValidationModel
  ) {
    dataItem.isEdited = true;
    if (
      dataItem['selectedDocumentRejectionReasons'] &&
      dataItem['selectedDocumentRejectionReasons'].length > 0
    ) {
      this.disableRequiredDocSave = false;
    }
  }

  getPoeDocumentType(documentType: string) {
    return EventDocumentType[documentType];
  }

  getReasons(reasons: EventDocumentRejectionReason[]) {
    return reasons
      ? reasons.map(s => s.rejectReasonDescription).join(', ')
      : '';
  }

  editCustomerValidation() {
    this.msgsCustValidation = [];
    this.isReadonlyCustomerValidation = false;
    this.btnNavCustValidation = true;
  }

  editCustomerValidationCancel() {
    this.isReadonlyCustomerValidation = true;
    this.msgsCustValidation = [];
    this.btnNavCustValidation = !this.btnNavCustValidation;
    this.getEventCustomerValidationInfo().subscribe(() => {
      this.loadEventCustomerValidationSection();
      this.getEventCustomerSurveyList();
    });
  }

  resetCustomerValidation() {
    this.eventCustomerValidations = [];
    this.btnNavCustValidation = false;
    this.getEventCustomerValidationInfo().subscribe(([,]) => {
      this.loadEventCustomerValidationSection();
      this.getEventCustomerSurveyList();
    });
  }

  cusSurveyResponse(SurveyGUID) {
    if (SurveyGUID == this.CusSurveyGUID) {
      this.CusSurveyGUID = '';
    } else {
      this.CusSurveyGUID = SurveyGUID;
      this.isSurveyResponseload = true;
      this.eventEdit
        .getCustomerSurveyResponse(SurveyGUID)
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(customerSurveyResponse => {
          for (const customerSurvey of this.eventCustomerSurveys) {
            if (customerSurvey.surveyGUID == SurveyGUID) {
              customerSurvey.responses = customerSurveyResponse.current;
            }
          }
          this.isSurveyResponseload = false;
        });
    }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
  }

  getEventCustomerSurveyList() {
    this.eventEdit
      .getEventCustomerSurveyList(this.customerId)
      .subscribe(eventCustomerSurveyListResponse => {
        if (
          eventCustomerSurveyListResponse != null &&
          eventCustomerSurveyListResponse.length > 0
        ) {
          eventCustomerSurveyListResponse.forEach(item => {
            item['isEdited'] = false;
            if (item.statusId != null) {
              item['isRejectedStatusSelected'] =
                this.rejectedSurveyStatus?.eventSurveyStatusId ===
                item.statusId;
            }
          });
          this.eventCustomerSurveys = eventCustomerSurveyListResponse;

          if (!this.checkIfCustomerSurveyNotOnetoMany()) {
            this.eventCustomerSurveys.forEach(survey => {
              if (
                survey.statusId !== Number(SurveyStatus.Rejected) &&
                survey.rejectionReasons == null
              ) {
                survey.rejectionReasons = [
                  this.eventCustomerSurveyRejectReasons[0]
                ];
              }
            });
          }
        } else {
          this.eventCustomerSurveys = [];
        }
      });
  }

  onChangeCustomerSurveySelectedStatus(dataItem: any) {
    dataItem['isEdited'] = true;
    if (dataItem['selectedStatus'] != null) {
      const isRejectedStatusSelected =
        dataItem['selectedStatus'].eventSurveyStatusId ===
        this.rejectedSurveyStatus?.eventSurveyStatusId;
      if (!isRejectedStatusSelected) {
        dataItem.rejectReasonDescription = '';
        dataItem.selectedReason = null;
      } else {
        dataItem.rejectReasonDescription =
          this.eventCustomerSurveyRejectReasons[0].rejectReasonDescription;
        dataItem.eventSurveyRejectReasonId =
          this.eventCustomerSurveyRejectReasons[0].eventSurveyRejectReasonId;
        dataItem.selectedReason = this.eventCustomerSurveyRejectReasons[0];
      }
      dataItem['isRejectedStatusSelected'] = isRejectedStatusSelected;
    }
    this.IsCustomerSurveyStatusValid();
  }

  onChangeCustomerSurveySelectedReason(dataItem: any) {
    dataItem['isEdited'] = true;
    this.IsCustomerSurveyStatusValid();
  }

  IsCustomerSurveyStatusValid() {
    for (const customerSurvey of this.eventCustomerSurveys) {
      const isRejected =
        customerSurvey.selectedStatus != null &&
        customerSurvey.selectedStatus.name === 'Rejected';

      if (
        isRejected === true &&
        (customerSurvey.rejectionReasons == null ||
          customerSurvey.rejectionReasons.length === 0)
      ) {
        this.disableCustSurveySave = true;
        return;
      } else {
        this.disableCustSurveySave = false;
      }
    }
  }

  ShowSelectedCustomerSurveyList(eventCustomerId, eventCustomerName) {
    this.customerId = eventCustomerId;
    this.customerName = eventCustomerName;
    this.getEventCustomerSurveyList();
    this.CusSurveyGUID = '';
  }

  editCustomerSurvey() {
    this.msgsCustSurvey = [];
    this.isReadonlyCustomerSurvey = false;
    this.btnCustomerSurvey = true;
    this.IsCustomerSurveyStatusValid();
  }

  editCustomerSurveyCancel() {
    this.isReadonlyCustomerSurvey = true;
    this.msgsCustSurvey = [];
    this.btnCustomerSurvey = !this.btnCustomerSurvey;
    this.resetCustomerSurvey();
  }

  resetCustomerSurvey() {
    this.eventCustomerSurveys = [];
    this.getEventCustomerSurveyList();
  }

  getSurveyReasons(reasons: EventSurveyRejectReason[]) {
    return reasons
      ? reasons.map(s => s.rejectReasonDescription).join(', ')
      : '';
  }

  updateCustomerSurvey() {
    const customerSurveySubmissionModel: CustomerSurveySubmissionModel = {
      CustomerSurveys: []
    };

    for (const customerSurvey of this.eventCustomerSurveys) {
      const isRejected =
        customerSurvey.selectedStatus != null &&
        customerSurvey.selectedStatus.name === 'Rejected';

      if (isRejected === true && customerSurvey.rejectionReasons.length === 0) {
        this.msgsCustSurvey = [];
        this.msgsCustSurvey.push({
          severity: 'warn',
          detail: 'Rejection reason for status Rejected must be selected'
        });
        return;
      }

      this.customerSurvey = {
        EventAttendeeSurveyMappingId:
          customerSurvey.eventAttendeeSurveyMappingId,
        StatusId: customerSurvey.selectedStatus.eventSurveyStatusId || -1,
        EventTypeSurveyMappingId: customerSurvey.eventTypeSurveyMappingId,
        EventSurveyRejectReasonIdList: isRejected
          ? customerSurvey.rejectionReasons
              .map(x => x.eventSurveyRejectReasonId)
              .filter((id): id is number => id !== undefined) || []
          : [],
        SurveyGUID: customerSurvey.surveyGUID
      };

      customerSurveySubmissionModel?.CustomerSurveys?.push(this.customerSurvey);
    }

    this.eventEdit
      .updateCustomerSurveys(customerSurveySubmissionModel)
      .subscribe(
        () => {
          this.btnCustomerSurvey = false;
          this.isReadonlyCustomerSurvey = true;
          this.getEventCustomerSurveyList();
          this.getEventPoeInformation();
          this.refreshEventDetails.emit();
          this.msgsCustSurvey = [];
          this.msgsCustSurvey.push({
            severity: 'success',
            detail: 'Customer Survey Saved Successfully.'
          });
        },
        () => {
          this.msgsCustSurvey = [];
          this.msgsCustSurvey.push({
            severity: 'warn',
            detail:
              'Sorry an Error Occured while Adding Customer Survey Details'
          });
        }
      );
  }

  downloadPOE(eventDocument: EventDocument) {
    const document = new EventPoeDocument();
    document.fileName = eventDocument.fileName;
    document.eventId = this.eventRegistrationId;
    this.eventEdit.getFileSasUrl(document).subscribe(downloadFileSasUrl => {
      window.location.href = downloadFileSasUrl;
    });
  }

  updateDocument() {
    const eventRegistrationDocumentStatusRequests: EventRegistrationDocumentStatusRequest[] =
      [];

    const editedDocumentList = this.documents.filter(x => x.isEdited === true);
    editedDocumentList.forEach(x => {
      const eventDocumentRejectionReasonIds =
        x.selectedDocumentRejectionReasons != null &&
        x.selectedDocumentRejectionReasons.length > 0
          ? x.selectedDocumentRejectionReasons.map(
              a => a.eventDocumentRejectionReasonId
            )
          : [];

      const selectedDocumentStatusId = (x as any).selectedDocumentStatus;
      const documentStatus = this.eventDocumentStatus.find(
        x => x.eventDocumentStatusId == selectedDocumentStatusId
      );

      const eventRegistrationDocumentStatusRequest: EventRegistrationDocumentStatusRequest =
        {
          eventRegistrationDocumentId: x.eventRegistrationDocumentId,
          eventDocumentStatusId: documentStatus?.eventDocumentStatusId || -1,
          eventDocumentRejectionReasonIds: eventDocumentRejectionReasonIds
        };

      eventRegistrationDocumentStatusRequests.push(
        eventRegistrationDocumentStatusRequest
      );
    });

    const updateRequest: UpdateEventDocumentsStatusRequest = {
      eventRegistrationDocumentStatusRequests:
        eventRegistrationDocumentStatusRequests
    } as UpdateEventDocumentsStatusRequest;

    this.eventEdit.updateEventDocumentsStatus(updateRequest).subscribe(
      isEventRegistrationDocumentsModified => {
        if (isEventRegistrationDocumentsModified) {
          this.refreshEventDetails.emit();
          this.msgsEventDocumentsStatus = [];
          this.msgsEventDocumentsStatus.push({
            severity: 'success',
            detail: !this.isMRPPProgram
              ? 'Event documents statuses saved successfully.'
              : 'Document(s) statuses Saved Successfully'
          });

          this.isPOEDocumentEditMode = false;
          this.reloadDocument();
        } else {
          this.isPOEDocumentEditMode = true;
          this.msgsEventDocumentsStatus = [];
          this.msgsEventDocumentsStatus.push({
            severity: 'warn',
            detail: !this.isMRPPProgram
              ? 'No event documents statuses were modified.'
              : 'No document(s) statuses were modified'
          });
        }
      },
      () => {
        this.msgsEventDocumentsStatus = [];
        this.msgsEventDocumentsStatus.push({
          severity: 'warn',
          detail: !this.isMRPPProgram
            ? 'Sorry an Error Occured while Updating Event Documents Status'
            : 'Sorry an Error Occured while Updating document(s) Status'
        });
      }
    );
  }

  editDocument() {
    this.isPOEDocumentEditMode = true;
  }

  resetDocument() {
    this.reloadDocument();
  }

  cancelDocument() {
    this.reloadDocument();
  }

  private reloadDocument() {
    this.loadDocuments();
    this.isPOEDocumentEditMode = false;
  }

  loadDocumentRejectionReasons() {
    this.eventEdit.getEventDocumentRejectionReasons().subscribe(result => {
      this.eventDocumentRejectionReasonsList = result;
    });
  }

  loadEventDocumentStatus() {
    this.eventEdit.getEventDocumentStatuses().subscribe(result => {
      this.eventDocumentStatus = result;
      if (result) {
        this.loadDocuments();
      }
    });
  }

  loadDocuments() {
    const eventtDocumentRequest = this.eventEdit.getEventDocuments(
      this.eventRegistrationId
    );
    const getEventDocumentStatusRequest =
      this.eventEdit.getEventDocumentStatuses();
    const getEventDocumentRejectionReasons =
      this.eventEdit.getEventDocumentRejectionReasons();
    forkJoin([
      eventtDocumentRequest,
      getEventDocumentStatusRequest,
      getEventDocumentRejectionReasons
    ]).subscribe(result => {
      this.eventRegistrationDocumentModel = result[0];
      this.eventDocumentStatus = result[1];
      this.eventDocumentRejectionReasonsList = result[2];
      const eventDocumentRejectionReasonsDictionary = new Map();
      this.eventDocumentRejectionReasonsList.forEach(item => {
        const key = item.eventDocumentTypeId;
        const collection = eventDocumentRejectionReasonsDictionary.get(key);
        if (!collection) {
          eventDocumentRejectionReasonsDictionary.set(key, [item]);
        } else {
          collection.push(item);
        }
      });

      this.documentHistories =
        this.eventRegistrationDocumentModel.documentHistories.filter(
          x => x.eventDocumentTypeId != 2
        );
      this.documents = this.eventRegistrationDocumentModel.documents.filter(
        x => x.eventDocumentTypeId != 2
      );

      if (
        this.programSharedService.checkEventType(EventType.TeamsRoomsOneToMany)
      ) {
        this.documents = this.eventRegistrationDocumentModel.documents.filter(
          x => x.eventDocumentTypeId != EventDocumentTypeIds.PublicSectorPOE
        );
        this.documentHistories =
          this.eventRegistrationDocumentModel.documentHistories.filter(
            x => x.eventDocumentTypeId != EventDocumentTypeIds.PublicSectorPOE
          );
      }
      for (const document of this.documents) {
        document.selectableEventDocumentRejectionReasons =
          eventDocumentRejectionReasonsDictionary.get(
            document.eventDocumentTypeId
          );
        if (document.documentStatus === 'Rejected') {
          document.isDocStatusRejectionVisible = true;
          document.selectedDocumentRejectionReasons =
            document.selectableEventDocumentRejectionReasons.filter(x =>
              document.eventDocumentRejectionReason?.some(
                r =>
                  r.eventDocumentRejectionReasonId ==
                  x.eventDocumentRejectionReasonId
              )
            );
        }
        document.isEdited = false;
        document.selectedDocumentStatus = this.eventDocumentStatus.find(
          x =>
            x.eventDocumentStatusId === (document as any).eventDocumentStatusId
        );
      }
    });
  }

  previewPoeDocument(poeFile: EventDocument, isSavedDocument: boolean) {
    if (!this.isMRPPProgram) {
      this.eventPreviewInput = {
        eventId: poeFile.eventRegistrationId,
        previewFileIndex: 0,
        eventIdList: [],
        isSavedDocumentPreview: isSavedDocument,
        hideNextPrevious: true,
        documentType: poeFile.documentType,
        fileName: poeFile.fileName
      } as any;

      if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.POEInvoice
      ) {
        this.eventPreviewInput.isPoeInvoicePreview = true;
        this.eventPreviewInput.isRollCallPreview = false;
        this.eventPreviewInput.isSKUPurchaseTrialPreview = false;
        this.eventPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.POETemplate
      ) {
        this.eventPreviewInput.isPoeInvoicePreview = false;
        this.eventPreviewInput.isSKUPurchaseTrialPreview = false;
        this.eventPreviewInput.isRollCallPreview = true;
        this.eventPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.POESKUTrial
      ) {
        this.eventPreviewInput.isPoeInvoicePreview = false;
        this.eventPreviewInput.isRollCallPreview = false;
        this.eventPreviewInput.isSKUPurchaseTrialPreview = true;
        this.eventPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) === EventDocumentType.SOW
      ) {
        this.eventPreviewInput.isPoeInvoicePreview = false;
        this.eventPreviewInput.isRollCallPreview = false;
        this.eventPreviewInput.isSKUPurchaseTrialPreview = false;
        this.eventPreviewInput.isSOWPreview = true;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.DealAssociationTemplate
      ) {
        this.eventPreviewInput.isPoeInvoicePreview = false;
        this.eventPreviewInput.isSKUPurchaseTrialPreview = false;
        this.eventPreviewInput.isRollCallPreview = false;
        this.eventPreviewInput.isSOWPreview = false;
        this.eventPreviewInput.isDAPOETemplate = true;
      }
    } else {
      this.mrppPreviewInput = {
        hideNextPrevious: true,
        eventId: poeFile.eventRegistrationId,
        previewFileIndex: 0,
        eventIdList: [],
        fileName: poeFile.fileName,
        isSavedDocumentPreview: isSavedDocument,
        eventTypeId: this.programSharedService.getEventType()
      } as any;

      if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.POEInvoice
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = true;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.DealAssociationTemplateRFP
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = true;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ==
        EventDocumentType.CustomerAwardLetter
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = true;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.CustomerPartnerOfRecord
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = true;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.DealAssociationTemplate
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = true;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.MADPOE
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isPublicSectorTemplate = false;
        this.mrppPreviewInput.isMicrosoftInvoiceTemplate = false;
        this.mrppPreviewInput.isPOETemplatePreview = false;
        this.mrppPreviewInput.isMADScreenshot = true;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.PublicSectorPOE
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isMADScreenshot = false;
        this.mrppPreviewInput.isMicrosoftInvoiceTemplate = false;
        this.mrppPreviewInput.isPOETemplatePreview = false;
        this.mrppPreviewInput.isPublicSectorTemplate = true;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.MicrosoftInvoiceTemplate
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isMADScreenshot = false;
        this.mrppPreviewInput.isPublicSectorTemplate = false;
        this.mrppPreviewInput.isPOETemplatePreview = false;
        this.mrppPreviewInput.isMicrosoftInvoiceTemplate = true;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) ===
        EventDocumentType.FindingsTemplate
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isMADScreenshot = false;
        this.mrppPreviewInput.isPublicSectorTemplate = false;
        this.mrppPreviewInput.isMicrosoftInvoiceTemplate = false;
        this.mrppPreviewInput.isPOETemplatePreview = true;
        this.mrppPreviewInput.isSOWPreview = false;
      } else if (
        this.getPoeDocumentType(poeFile.documentType) === EventDocumentType.SOW
      ) {
        this.mrppPreviewInput.isPoeInvoicePreview = false;
        this.mrppPreviewInput.isSKUPurchaseTrialPreview = false;
        this.mrppPreviewInput.isRollCallPreview = false;
        this.mrppPreviewInput.isDealAssociationCPORTemplate = false;
        this.mrppPreviewInput.isDealAssociationPoeTemplate = false;
        this.mrppPreviewInput.isMADScreenshot = false;
        this.mrppPreviewInput.isPublicSectorTemplate = false;
        this.mrppPreviewInput.isMicrosoftInvoiceTemplate = false;
        this.mrppPreviewInput.isPOETemplatePreview = false;
        this.mrppPreviewInput.isSOWPreview = true;
      }
    }

    this.canShowEventPreviewModel = true;
  }

  closePreview() {
    this.canShowEventPreviewModel = false;
    this.reloadDocument();
    this.isReadonlyCustomerValidation = true;
    this.btnPoeStatus = false;
    this.getEventPoeInformation();
    this.refreshEventDetails.emit();
  }

  showCustomerValidationPreview(
    eventCustomerValidation: EventCustomerValidationModel
  ) {
    this.canShowCustomerValidationPreviewModel = true;
    this.customerValidationPreviewInput = {
      eventId: this.eventRegistrationId,
      eventIdList: [],
      isEditPreview: true,
      customerName: eventCustomerValidation.customerName
    };
  }

  closeCustomerValidationPreview() {
    this.canShowCustomerValidationPreviewModel = false;
    this.resetCustomerValidation();
  }

  get EventType(): typeof EventType {
    return EventType;
  }

  onPoeDocumentUploadClick(documentType: number) {
    this.docType = documentType;
    this.loadUploadDialog = true;
  }

  get fileUploadHeader(): string {
    const labels = {
      [EventDocumentTypeIds.DealAssociationTemplate]:
        'Upload Deal Association Template',
      [EventDocumentTypeIds.CustomerPartnerOfRecord]:
        'Upload Customer partner of record POE document',
      [EventDocumentTypeIds.DealAssociationTemplateRFP]:
        'Upload Deal Association Template RFP',
      [EventDocumentTypeIds.CustomerAwardLetter]:
        'Upload Customer Award Letter',
      [EventDocumentTypeIds.MicrosoftInvoiceTemplate]:
        'Upload Microsoft Invoice Template',
      [EventDocumentTypeIds.PublicSectorPOE]: 'Upload Public Sector Template',
      [EventDocumentTypeIds.FindingsTemplate]: 'Upload POE Template',
      [EventDocumentTypeIds.POEInvoice]: 'Upload POE Invoice'
    };

    return labels[this.docType] || '';
  }

  formatBytes(bytes: number, decimals: number) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  private clearHtmlFileInput() {
    this.myfileInput.nativeElement.value = '';
  }

  private isValidFileExtension(file: File): boolean {
    if (AppConstants.commonFileTypes.length > 0) {
      const isValidFileType = AppConstants.commonFileTypes.includes(file.type);
      if (!isValidFileType) {
        let errorMessage = '';
        if (AppConstants.commonFileTypesDisplayNames) {
          errorMessage = `File type must be ${AppConstants.commonFileTypesDisplayNames.join(', ')}`;
        } else {
          errorMessage = `File type must be ${AppConstants.commonFileTypes.map(x => x.split('/')[1]).join(', ')}`;
        }

        this.umsgs = [];
        this.umsgs.push({ severity: 'error', detail: errorMessage });
        setTimeout(() => {
          this.umsgs = [];
        }, 6000);
        this.clearHtmlFileInput();
        return false;
      }
    }
    return true;
  }

  private isValidFileSize(file: File): boolean {
    const fileSizeinMB = file.size / (1024 * 1000);
    const size = Math.round(fileSizeinMB * 100) / 100;

    if (size > 10) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail:
          'Error (File Size): ' +
          file.name +
          ': exceed file size limit of 10 MB '
      });
      setTimeout(() => {
        this.umsgs = [];
      }, 6000);
      this.clearHtmlFileInput();
      return false;
    }
    return true;
  }

  uploadFile(event: string | any[]) {
    const fileToAttach = event[0] as File;
    if (event.length > this.poeDocMaximumFiles) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail: 'Multiple files are not allowed to upload'
      });
      this.clearHtmlFileInput();
    } else if (
      this.isValidFileExtension(fileToAttach) &&
      this.isValidFileSize(fileToAttach)
    ) {
      this.uploadPOEDocumentToBlob(fileToAttach);
    }
  }

  uploadPOEDocumentToBlob(fileUpload: File) {
    const formData = new FormData();
    formData.append('file', fileUpload, fileUpload.name);

    const newFile: PoeDocument = {
      fileName: fileUpload.name,
      size: fileUpload.size
    } as PoeDocument;

    if (
      this.filesUpload.find(a => a.fileName === newFile.fileName) === undefined
    ) {
      if (this.filesUpload.length === 0 || this.filesUpload.length !== 1) {
        this.filesUpload.push(newFile);
        this.fileUploadSpinners.push(true);
        this.uploadPOEDocToBlob(formData);
      } else {
        this.umsgs = [];
        this.umsgs.push({
          severity: 'error',
          detail: 'Possible upload only one file in list'
        });
        setTimeout(() => {
          this.umsgs = [];
        }, 6000);
      }
    } else {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'error',
        detail: fileUpload.name + ' file already exits in list'
      });
      setTimeout(() => {
        this.umsgs = [];
      }, 6000);
    }
  }

  uploadPOEDocToBlob(formData: any) {
    this.isUploading = true;
    this.eventEdit
      .uploadPOEDocToBlob(formData, this.eventRegistrationId.toString())
      .subscribe(
        (results: any) => {
          this.storePOEDocument = results;
          this.isUploading = false;
          const finalFile = this.filesUpload.find(
            a => a.fileName === results.fileName
          );
          const idx = this.filesUpload.indexOf(finalFile);
          this.fileUploadSpinners[idx] = false;
        },
        error => {
          this.isUploading = false;
          this.umsgs = [];
          if (error.status === 500) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else if (error.status === 502) {
            this.umsgs.push({ severity: 'error', detail: error.statusText });
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          } else {
            this.umsgs.push({
              severity: 'warn',
              detail: 'Sorry an Error Occured while uploading a file'
            });
            this.filesUpload = [];
            this.fileUploadSpinners = [];
            setTimeout(() => {
              this.umsgs = [];
            }, 4000);
          }
        }
      );
  }

  submitFile() {
    if (this.isUploading) {
      this.umsgs = [];
      this.umsgs.push({
        severity: 'warn',
        detail: 'Please wait, file is still uploading.'
      });
      this.isButtonActive = false;
      setTimeout(() => {
        this.umsgs = [];
        this.isButtonActive = true;
      }, 4000);
      return;
    }
    if (this.storePOEDocument === undefined || this.storePOEDocument === null) {
      this.umsgs = [];
      const noFileError = 'Upload POE Document to submit';
      this.umsgs.push({ severity: 'error', detail: noFileError });
      setTimeout(() => {
        this.umsgs = [];
      }, 4000);
    } else {
      this.submitUploadedPOEDocuments();
    }
  }

  submitUploadedPOEDocuments() {
    const poeDocument: ProgramDocument = {
      eventRegistrationId: this.eventRegistrationId,
      eventTypeDocumentMappingId:
        (this.documents &&
          this.documents.find(x => x.eventDocumentTypeId == this.docType)
            ?.eventTypeDocumentMappingId) ||
        -1,
      fileName: this.storePOEDocument.fileName || '',
      filePath: this.storePOEDocument.url || '',
      Status: DocumentStatus.InReview
    };

    this.eventEdit.UploadPoeDocuments(poeDocument).subscribe(
      () => {
        this.cancelUploadDocument();
        this.isReadonlyCustomerValidation = true;
        this.btnPoeStatus = false;
        this.getEventPoeInformation();
        this.reloadDocument();
        this.refreshEventDetails.emit();
      },
      error => {
        if (error.status === 500) {
          this.umsgs = [];
          this.umsgs.push({ severity: 'error', detail: error.error.errorInfo });
          setTimeout(() => {
            this.umsgs = [];
          }, 2000);
        } else {
          this.umsgs = [];
          this.umsgs.push({
            severity: 'warn',
            detail: 'Sorry an Error Occured'
          });
        }
      }
    );
  }

  cancelUploadDocument() {
    this.loadUploadDialog = false;
    this.clearHtmlFileInput();
    this.storePOEDocument = {};
    this.filesUpload = [];
  }

  isCustomerSectionEnabled() {
    const allowedTypes = [EventType.TeamsRoomsOneToMany];
    return allowedTypes.some(type =>
      this.programSharedService.checkEventType(type)
    );
  }

  isSubscriptionVisible() {
    const allowedTypes = [EventType.TeamsRoomsOneToMany];
    return allowedTypes.some(type =>
      this.programSharedService.checkEventType(type)
    );
  }

  isPOECompleted() {
    return (
      this.eventPOEStatusId !== undefined &&
      this.eventPOEStatusId == POEStatus.Completed
    );
  }

  isDisabledEdit() {
    const allowedTypes = [EventType.TeamsRoomsOneToMany];
    return (
      this.isPOECompleted() &&
      allowedTypes.some(type => this.programSharedService.checkEventType(type))
    );
  }

  checkIfCustomerSurveyNotOnetoMany() {
    return (
      this.surveyDetails &&
      this.surveyDetails.hasCustomerSurvey &&
      !this.surveyDetails.isOneToMany
    );
  }

  isSurveyEditDisabled(dataItem: CustomerSurveyModel) {
    const allowedTypes = [EventType.TeamsRoomsOneToMany];
    return (
      dataItem.statusId == Number(SurveyStatus.Completed) &&
      allowedTypes.some(type => this.programSharedService.checkEventType(type))
    );
  }
}
